import React from "react";

// `fill` defaults to the original neutral grey so every existing
// usage stays visually identical; callers that render on a dark
// background pass `fill="white"` (or any valid CSS colour) to keep
// the icon legible.
const CrossIcon = ({ fill = "#8E8E8E" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.00049 13.5864C0.609989 13.977 0.610049 14.6101 1.00061 15.0006C1.39117 15.3911 2.02433 15.3911 2.41482 15.0005L8.00006 9.41427L13.5858 15C13.9763 15.3905 14.6095 15.3905 15 15C15.3905 14.6095 15.3905 13.9763 15 13.5858L9.41416 7.99997L14.9996 2.41359C15.39 2.02303 15.39 1.38987 14.9994 0.999381C14.6089 0.608881 13.9757 0.60894 13.5852 0.9995L7.99986 6.58577L2.41414 0.999981C2.02362 0.60946 1.39045 0.60946 0.999929 0.999981C0.609399 1.39051 0.609399 2.02367 0.999929 2.4142L6.58586 8.00007L1.00049 13.5864Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default CrossIcon;
